const getters = {
  isOptimaLoading: state => state.isOptimaLoading,
  isOptimaUpdating: state => state.isOptimaUpdating,
  isOptimaOrderLoading: state => state.isOptimaOrderLoading,
  all: state => state.all,
  totals: state => state.totals,
  orderDetails: state => state.orderDetails,
  compareList: state => state.compareList,
  editOrderIds: state => state.editOrderIds,
  materials: state => state.materials,
  consignees: state => state.consignees,
  default_settings: state => state.settings,
  defaultDepot: state => state.defaultDepot,
  xlsMaterials: state => state.xls_materials,
  vehicles: state => state.vehicles,
  not_combines: state => state.not_combines,
  isLoading: state => state.isLoading,
  optimaAutoRun: state => state.optimaAutoRun,
  selectedIndentMap: state => state.selectedIndentMap,
  indentIdWiseData: state => state.indentIdWiseData,
  indentBucket: state => state.indentBucket,
  configurations: state => state.data && state.data.configurations,
  optimaRejectionsListData: state => state.optimaRejectionsListData,
  optimaAutoIndent: state => state.optimaAutoIndent,
  optimaCurrentJobId: state => state.optimaCurrentJobId,
  optimaCurrentPage: state => state.optimaCurrentPage,
  deliveryPicklist: state => state.deliveryPicklist,
  selectedPicklistMap: state => state.selectedPicklistMap,
  picklistIdsMap: state => state.picklistIdsMap,
  selectAllPicklistConsignees: state => state.selectAllPicklistConsignees,
  deliveryIndentsPickList: state => state.deliveryIndentsPickList,
  showIndentTopupDrawer: state => state.showIndentTopupDrawer,
  splitObject: state => state.splitObject,
  combineObject: state => state.combineObject,
  splitOrderSelectedIndex: state => state.splitOrderSelectedIndex,
  combineOrderSelectedIndex: state => state.combineOrderSelectedIndex,
  returnContracts: state => state.returnContracts,
  combineAndSplitBtnDisable: state => state.combineAndSplitBtnDisable,
  contractCollection: state => state.contractCollection,
};

export default getters;
